class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static requiredQty = 5;

    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        const cartQty = parseInt(cart.item_count, 10) || 0;
        const requiredQty = FreeShippingMeter.requiredQty;

        let freeShipBar = Math.abs((cartQty * 100) / requiredQty);

        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }

        const text = this.getText(cartQty, requiredQty);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartQty, requiredQty) {
        let text;

        if (cartQty === 0) {
            this.progressBar.classList.add('progress-hidden');

            text =
                '<span>Add </span>' +
                '<strong class="shipping-price">' + requiredQty + '</strong>' +
                '<span> items to unlock </span>' +
                '<span class="text">free shipping</span>';
        } else if (cartQty >= requiredQty) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;

            text =
                '<span>You have unlocked </span>' +
                '<span class="text">free shipping</span>' +
                '<span>!</span>';
        } else {
            this.progressBar.classList.remove('progress-hidden');

            const remainingQty = requiredQty - cartQty;

            text =
                '<span>Only </span>' +
                '<strong class="shipping-price">' + remainingQty + '</strong>' +
                '<span> more item' + (remainingQty > 1 ? 's' : '') + ' away from </span>' +
                '<span class="text">free shipping</span>';
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free';
        }

        return classLabel;
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            if (this.progressMeter) {
                this.progressMeter.style.width = `${freeShipBar}%`;

                if (this.textEnabled) {
                    const percentText = this.progressMeter.querySelector('.text');
                    if (percentText) {
                        percentText.innerHTML = `${freeShipBar.toFixed(2)}%`;
                    }
                }
            }

            if (this.messageElement) {
                this.messageElement.innerHTML = text;
            }
        }, 400);
    }
}

window.addEventListener('load', () => {
    if (!customElements.get('free-shipping-component')) {
        customElements.define('free-shipping-component', FreeShippingMeter);
    }
});